import styled from 'styled-components';
import theme from 'src/theme';

export type PanelProps = {
    columns?: string;
    height?: string;
    width?: string;
    top?: string;
    left?: string;
};

export type SectionProps = {
    alignTop?: boolean;
    noMargin?: boolean;
};

export const PanelWrapperStyle = styled.div<PanelProps>`
    position: absolute;
    z-index: 12;
    box-shadow: #ccc 0px 2px 6px 2px;
    font-size: 0.8rem;
    background: #fff;
    width: ${(props) => (props.width ? props.width : '100%')};
    top: ${(props) => (props.top ? props.top : '0')};
    left: ${(props) => (props.left ? props.left : '0')};
`;

export const PanelHeaderStyle = styled.div`
    display: flex;
    align-items: center;
    background: ${theme.legacyColors.panelHeadingBackground};
    color: ${theme.legacyColors.panelHeadingTextColor};
    font-weight: 600;
    border-bottom: 1px solid #dde5cc;
    justify-content: space-between;
`;

export const PanelHeader = styled(PanelHeaderStyle) <PanelProps>`
    height: 60px;
`;

export const TabsPanelHeader = styled(PanelHeader) <PanelProps>`
    display: grid;
    grid-template-columns: ${(props) => props.columns ?? 'unset'};
    align-items: center;
    background: #fff;
    padding: 7px 10px 0 7px;
    height: ${(props) => props.height ?? '60px'};
    color: inherit;
    border-bottom: 2px solid ${theme.legacyColors.headingColor};
    position: relative;
    width: 100%;

    @media print {
        display: none;
    }
`;

export const DropdownWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 175px;
    font-size: 0.8rem;
    color: #00447e;

    label {
        font-weight: 500;
        font-size: 0.75rem;
        margin-bottom: 2px;
    }

    &.verification-header-select {
        label {
            font-size: 0.7rem;
            margin-bottom: -1px;
        }
        .dropdown-heading {
            height: 22px;
        }

        .dropdown-heading-dropdown-arrow svg {
            height: 20px;
        }
        .dropdown-heading-value {
            color: hsl(0, 0%, 20%);
            font-size: 0.75rem;
            * {
                color: hsl(0, 0%, 20%);
            }
        }
    }

    .dropdown-heading {
        height: 28px;
        .dropdown-heading-dropdown-arrow svg {
            height: 20px;
        }
        .dropdown-heading-value {
            color: hsl(0, 0%, 20%);
            font-size: 0.8rem;
            * {
                color: hsl(0, 0%, 20%);
            }
        }
    }

    .dropdown-content {
        .panel-content {
            background: #fff;
        }

        label.select-item {
            margin: 0 2px 0 0;
            font-weight: 500;
            font-size: 0.8rem;
            font-weight: 400;
            border-bottom: 1px solid #ddd;
            background: #fff;
        }

        .item-renderer > span {
            display: inline;
            padding-left: 3px;
        }
    }
`;

export const StatusInfoWrapper = styled.div<PanelProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    @media print {
        display: none;
    }
`;

export const OrderInfoWrapper = styled.div<PanelProps>`
    display: flex;
    justify-content: flex-start;
    padding: 0 1rem 0 0;
    align-items: center;
`;

export const StatusWrapper = styled.div<PanelProps>`
    display: flex;
    justify-content: center;
    grid-gap: 1rem;
    align-items: baseline;
    @media print {
        display: none;
    }
`;

export const ReportingContextInfo = styled.div`
    display: flex;
    justify-content: center;
    grid-gap: 1rem;

    .port-call-name{
        font-weight: 600;
        color: rgb(0, 68, 126);
        border: 1px solid rgb(239 236 236);
        border-radius: 4px;
        padding: 7px 15px;
        background: rgb(248, 248, 248);
        margin: 0 0 0 5px;
    }
`;

